import moment from "moment";
import { useState } from "react";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import {
  Badge,
  Button,
  Col,
  Label,
  Modal,
  ModalBody,
  Row,
  Spinner,
} from "reactstrap";
import { processPayment } from "../../api/payment.api";
import FormInput from "../formInput/FormInput";
import { FiDollarSign } from "react-icons/fi";
import { IoCloseSharp } from "react-icons/io5";
const AddNewCreditCard = ({ modal, toggle, state }) => {
  const [cardNumber, setCardNumber] = useState("");
  const [cvc, setCvc] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [amount, setAmount] = useState(state?.total ?? 0);
  const [loading, setLoading] = useState(false);
  const { user } = useSelector((state) => state.auth);
  const handlePayment = async () => {
    setLoading(true);
    let formateYear = moment(expiryDate).format("YY");
    let formateMonth = moment(expiryDate).format("MM");
    let formateCardNumber = cardNumber.replace(/\s/g, "");
    const pay_forOrder_data = {
      orderIds: [state?._id],
      cardNumber: formateCardNumber,
      cardCode: cvc,
      expiryDate: `${formateMonth}/${formateYear}`,
      amount: amount,
    };
    if (state?.paymentStatus === "Paid") {
      toast.error("No Duplicate Transactions allowed.");
      return;
    }
    await processPayment(pay_forOrder_data, (res) => {
      if (res?.status === 200) {
        toast.success(res.data.message);
        setLoading(false);
        toggle();
      } else {
        toast.error(res?.message || res?.details || "Payment Failed");
        setLoading(false);
      }
    });
  };
  return (
    <div>
      <Modal isOpen={modal} toggle={toggle} centered size="lg">
        <div className="d-flex justify-content-between align-items-center p-4 border-bottom bg-light rounded-top">
          <h5 className="fw-bold text-dark mb-0 d-flex align-items-center gap-2">
            <FiDollarSign className="text-primary" /> Pay for Order
          </h5>
          <IoCloseSharp size={24} className="text-muted pointer hover-opacity-75" onClick={toggle} style={{ cursor: "pointer" }} />
        </div>
        <ModalBody className="p-3">
          <form onSubmit={handlePayment}>
            <div className="d-flex justify-content-between align-items-center mb-3">

              {state?.paymentStatus === "Paid" && (
                <Badge
                  color={`${state?.paymentStatus === "Paid" ? "success" : "info"
                    }`}
                >
                  {" "}
                  Payment has been Processed - {state?.paymentStatus}
                </Badge>
              )}
            </div>
            <Row className="mb-3">
              <Col md={3}>
                <FormInput
                  type={"number"}
                  label={"Card Number #"}
                  placeholder={"00"}
                  className={`sales__inputCustomer `}
                  value={cardNumber}
                  handleChange={(e) => setCardNumber(e.target.value)}
                  readOnly={state?.paymentStatus === "Paid"}
                />
              </Col>
              <Col md={3}>
                <FormInput
                  type={"number"}
                  label={"CVC"}
                  placeholder={"00"}
                  className={`sales__inputCustomer `}
                  value={cvc}
                  handleChange={(e) => setCvc(e.target.value)}
                  readOnly={state?.paymentStatus === "Paid"}
                />
              </Col>
              <Col md={3}>
                <Label className="fw-bold mb-0">Expiry Date</Label>
                <FormInput
                  label={"Expire Date"}
                  fontWeight={"500"}
                  monthYear
                  handleChange={(e) => {
                    setExpiryDate(e);
                  }}
                  state={expiryDate}
                />
              </Col>
              <Col md={3}>
                <FormInput
                  type={"number"}
                  label={"Amount"}
                  placeholder={"00"}
                  className={`sales__inputCustomer `}
                  value={amount}
                  handleChange={(e) => setAmount(e.target.value)}
                  readOnly={state?.paymentStatus === "Paid"}
                />
              </Col>

              <div className="d-flex justify-content-end">
                <Button
                  size="sm"
                  className={"white-button mx-2"}
                  onClick={toggle}
                >
                  Cancel
                </Button>
                <Button
                  size="sm"
                  className={"blue-button mx-2"}
                  onClick={handlePayment}
                  disabled={loading}
                >
                  {loading ? <Spinner size={"sm"} /> : "Authorize Payment"}
                </Button>
              </div>
            </Row>
          </form>
        </ModalBody>
      </Modal>
    </div>
  );
};
export default AddNewCreditCard;
